import { ChatContextProvider } from "../../context/ChatContext";
import ChatPage from "./ChatPage";

export default function ChatPageWrapper() {
  return (
    <ChatContextProvider>
      <ChatPage />
    </ChatContextProvider>
  );
}
